export default __webpack_public_path__ + "static/media/DARK WORKING SYSTEM  ACCIDENT SIMULATOR.2fa5f87f.jpg";